<script setup lang="ts">
import { ref, watch } from "vue";

const props = defineProps<{
  name: string;
  initials: string;
  photoUrl?: string;
}>();

const imageFailed = ref(false);

watch(
  () => props.photoUrl,
  () => {
    imageFailed.value = false;
  },
);
</script>

<template>
  <span
    class="avatar person-avatar"
    role="img"
    :aria-label="name"
    :title="name"
  >
    <img
      v-if="photoUrl && !imageFailed"
      :src="photoUrl"
      alt=""
      @error="imageFailed = true"
    />
    <span v-else aria-hidden="true">{{ initials }}</span>
  </span>
</template>

<style scoped>
.person-avatar {
  overflow: hidden;
}
.person-avatar img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
</style>
